import * as jQuery from 'jquery'

jQuery.validator.unobtrusive.adapters.add(
    'ladencargo', ['properties'], function (options) {
        options.rules['ladencargo'] = options.params;
        options.messages['ladencargo'] = options.message;
    }
);

jQuery.validator.addMethod('ladencargo', function (value, element, params) {
    var properties = params.properties.split(',');
    var shipStatusRule = properties[0];
    var regExRule = new RegExp(properties[1]);
    var vesselTypeValue = $('#' + properties[2]).val();
    var shipStatusValue = $('input:radio[name="' + properties[3] + '"]:checked').val();

    var validVesselType = regExRule.test(vesselTypeValue);
    var isLaden = shipStatusValue === shipStatusRule;
    if (!validVesselType) {
        return true;
    }
    if (!value && isLaden) {
        return false;
    }
    return true;
}, '');

$.fn.ForceNumericOnly =
    function () {
        this.keypress(function (e) {
            var value = $(this).val();
            if (value.indexOf(',') !== -1) {
                $(this).val(value.replace(/,/g, "."));
            }
        });
    };

$.fn.popoverClosable = function (options) {
    var defaults = {
        template:
            '<div class="popover">\
            <div class="arrow"></div>\
            <div class="popover-header">\
            <button type="button" class="close" data-dismiss="popover" aria-hidden="true">x</button>\
            <h3 class="popover-title"></h3>\
            </div>\
            <div class="popover-content"></div>\
            </div>'
    };
    options = $.extend({}, defaults, options);
    var $popover_togglers = this;
    $popover_togglers.popover(options);
    $popover_togglers.on('click', function (e) {
        e.preventDefault();
        $popover_togglers.not(this).popover('hide');
    });
    $('html').on('click touchstart', '[data-dismiss="popover"]', function (e) {
        $popover_togglers.popover('hide');
    });
    // Add outside click close
    $('body').on('click touchstart', function (e) {
        $('[data-toggle="popover"]').each(function () {
            // the 'is' for buttons that trigger popups
            // the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
    // Hack for double click bug
    // https://github.com/twbs/bootstrap/issues/16732
    $('body').on('hidden.bs.popover', function (e) {
        $(e.target).data("bs.popover").inState = { click: false, hover: false, focus: false }
    });
}

function handleLadenCargo() {
    var checkedValue = $('input:radio[name="Calculator.ShipStatus"]:checked').val();
    var shipType = $('#VesselType').val();
    var exceptionShipInBallast = "GeneralCargoShips";

    if (!checkedValue) {
        return;
    }
    var $calculator = $('form#tollCalculator');
    var $teu = $('#Teu');
    var $emptyTeu = $('#EmptyTeu')

    if (checkedValue === 'Ballast') {
        if ($teu.length && $teu.length > 0) {
            $calculator.validate().element($teu);
            $teu.prop('disabled', true);
        }
        if ($emptyTeu.length && $emptyTeu.length > 0 && shipType != exceptionShipInBallast) { // Empty TEU possible to add in balast for GeneralCargo
            $calculator.validate().element($emptyTeu);
            $emptyTeu.prop('disabled', true);
        }

    } else {
        if ($teu.length && $teu.length > 0) {
            $teu.prop('disabled', false);
        }
    }
}

(function () {
    var KeyCodes = {
        TAB: 9
    };
    var forEach = Array.prototype.forEach;

    function synchronizeSelect(target, isInit) {
        if (target.hasAttribute("data-synchronized-select")) {
            let labelElement = target.parentElement.querySelector("[data-synchronized-select-label]");
            if (labelElement) {
                if (isInit && !target.value) {
                    return;
                }

                labelElement.innerHTML = target[target.selectedIndex].text;
            }
        }
    };

    function handleSelectFocus(element) {
        element.addEventListener("focus", function () {
            element.parentElement.setAttribute("data-focus", "");
        });

        element.addEventListener("blur", function () {
            element.parentElement.removeAttribute("data-focus");
        });
    };

    function showWhenSelected(showTargets, select, negativeAttribute) {
        if (!select.selectedOptions && !select.options[select.selectedIndex]) {
            return;
        }
        var selectedOption = !select.selectedOptions ? select.options[select.selectedIndex] : select.selectedOptions[0];
        var id;

        if (selectedOption) {
            id = selectedOption.value;
        } else {
            id = null;
        }

        forEach.call(showTargets, function (target) {
            var selectedTargets = target.getAttribute("data-show-when-selected-target").split(",");
            var validRule = false;
            selectedTargets.forEach(function (value) {
                if (value === id) {
                    validRule = true;
                }
            });

            if (validRule) {
                target.setAttribute("data-show-when-selected-visible", "");

                if (negativeAttribute) {
                    target.removeAttribute(negativeAttribute);
                }
            } else {
                target.removeAttribute("data-show-when-selected-visible");

                if (negativeAttribute) {
                    target.setAttribute(negativeAttribute, "");
                }
            }
        });
    };

    function attachShowWhenSelected(additionalAttribute) {
        var selects = document.querySelectorAll("[data-show-when-selected]");
        var showTargets = document.querySelectorAll("[data-show-when-selected-target]");

        forEach.call(selects, function (select) {
            showWhenSelected(showTargets, select, additionalAttribute);

            select.addEventListener("change", function (e) {
                showWhenSelected(showTargets, select, additionalAttribute);
            });
            select.addEventListener("keyup", function (e) {
                showWhenSelected(showTargets, select, additionalAttribute);
            });
        });
    };

    function initMandatoryTugGuard() {
        var mandatoryTugInputs = document.querySelectorAll("[data-mandatory-tug]");

        forEach.call(mandatoryTugInputs, function (mandatoryTugInput) {
            mandatoryTugInput.addEventListener("change", function (e) {
                if (e.target.value > 14.33) {
                    e.target.parentElement.setAttribute("data-mandatory-tug-visible", "");
                } else {
                    e.target.parentElement.removeAttribute("data-mandatory-tug-visible");
                }
            });
        });
    };

    function init() {
        var IGNORE_VALIDATION_ATTRIBUTE_NAME = "data-ignore-validation";
        attachShowWhenSelected(IGNORE_VALIDATION_ATTRIBUTE_NAME);
        handleLadenCargo();
        initMandatoryTugGuard();
    };
    init();
})();

(function () {
    $('[data-toggle="popover"]').popoverClosable({
        html: true
    });
    $('[data-force-numeric]').each(function() {
        $(this).ForceNumericOnly();
    });
    $('input:radio[name="Calculator.ShipStatus"]').change(function () {
        handleLadenCargo();
    });

    $(document).on('click', 'form.tollCalculator input[type=submit]', function (e) {
        var isValid = $(e.target).parents('form').valid();
        if (!isValid) {
            e.preventDefault(); // prevent the default action
        }
    });
})();
